import React from 'react';

import { ListDescription } from '../../ListDescription.js';

type TopListHeroProps = {
  title: string;
  description: string;
};

const TopListHero: React.FC<TopListHeroProps> = ({ title, description }) => (
  <section className="top-list__hero">
    <h1>{title}</h1>
    <ListDescription className="top-list__description" text={description} />
  </section>
);

export { TopListHero };
